const minQuery = (size) => `@media (min-width: ${size}px)`

export default {
  tablet: minQuery(768),
  laptop: minQuery(900),
}
